import React, { useState, useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { Navbar, Nav, Form, FormControl } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import logoImage from "../../images/Todaylocal - logo.jpg";
import "../NavBar/NavBar.css";
import axios from "../../axiosInstance"; // Axios instance for API requests

function NavBar({ searchQuery, setSearchQuery }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [newsItems, setNewsItems] = useState([]);

  // Define navigation links with page route and API key
  const navs = [
    { nav: "Home", page: "/", apiKey: "" },  // Home doesn't fetch news
    { nav: "Breaking News", page: "/category/breaking-news", apiKey: "breaking-news" },
    { nav: "Live", page: "/category/live", apiKey: "live" },
    { nav: "Entertainment", page: "/category/entertainment", apiKey: "entertainment" },
    { nav: "Cinema", page: "/category/cinema", apiKey: "cinema" },
    { nav: "Sports", page: "/category/sports", apiKey: "sports" },
    { nav: "Astrology", page: "/category/astrology", apiKey: "astrology" },
    { nav: "Devotional", page: "/category/devotional", apiKey: "devotional" },
    { nav: "Jobs", page: "/category/jobs", apiKey: "jobs" },
    { nav: "Others", page: "/category/others", apiKey: "others" },
  ];

  // Fetch news by category using the API key
  const fetchNewsByCategory = async (apiKey) => {
    if (!apiKey) {
      console.error("API Key is undefined. Skipping API call.");
      return;
    }
    console.log("API Key being passed:", apiKey);  // Log the apiKey to check its value
    try {
      const response = await axios.get(`/api/news/category/${apiKey}`);
      setNewsItems(response.data);
    } catch (error) {
      console.error("Error fetching category news:", error);
    }
  };
  
  

  // Handle search query input
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle category change by passing the API key for the selected category
  const handleCategoryChange = (apiKey) => {
    fetchNewsByCategory(apiKey);
  };

  return (
    <Navbar
      className="user-navbar"
      variant="dark"
      expand="lg"
      fixed="top"
      expanded={!isCollapsed}
    >
      <Navbar.Brand className="user-nav-brand" href="/">
       {/*  <img src={logoImage} alt="Logo" className="user-logo" />*/}
        Today Local
      </Navbar.Brand>

      {isCollapsed && (
        <Navbar.Toggle
          className="user-border-0"
          aria-controls="basic-navbar-nav"
          onClick={() => setIsCollapsed(!isCollapsed)}
        />
      )}

      {!isCollapsed && (
        <IoCloseOutline
          size={40}
          className="user-close-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
        />
      )}

      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="user-nav mr-auto">
          {navs.map((navItem) => (
            <LinkContainer to={navItem.page} key={navItem.nav}>
              <Nav.Link
                className="user-nav-item"
                onClick={() => handleCategoryChange(navItem.apiKey)} // Use navItem.apiKey to fetch news
              >
                {navItem.nav}
              </Nav.Link>
            </LinkContainer>
          ))}
        </Nav>

        {/* Search Form */}
        <Form className="d-flex user-search-form">
          <FormControl
            type="search"
            placeholder="Search news..."
            className="me-2 user-form-input"
            value={searchQuery}
            onChange={handleInputChange}
          />
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavBar;
